import { clientSpecialPackageAddTheadData } from '../../../data/admin-data'

export default function SpecialPackageAddProductTHead() {
    return (
        <thead className='bg-gray-50 text-black uppercase text-xs sticky top-0'>
            <tr className='bg-gray-300 text-gray-900'>
                {clientSpecialPackageAddTheadData.map((header, index) => (
                    <th key={index} className={`px-2.5 py-1.5 text-left border border-gray-200`}>
                        {header.name}
                    </th>
                ))}
            </tr>
        </thead>
    )
}
